import { getUrl, GET_PERMISSIONS_URL } from "config/endpoints";
import { getRequest } from "api";

export const getPermissions = async (accountId: string): Promise<any> => {
  const url = getUrl(GET_PERMISSIONS_URL, { accountId });
  return getRequest(url);
};
